import { __awaiter } from "tslib";
import fetch from '../fetch';
import conf from '../../conf';
import { getRiskAssessmentPricingData, getContact } from '../helpers';
import { selectReturnsPricingData } from '../../selectors/returns';
import { setCountriesData, setRegionsData } from '../../store/data';
import { setReturnsSalesTax } from '../../store/returns';
import { setRiskAssessmentSalesTax } from '../../store/risk-assessment';
import { basePostParams } from './index';
import { receiveConnectorSalesTax, } from '../../store/buy-flow';
import { getSystemErrorMessaging } from './error';
export const getSalesTax = (body, dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const postParams = Object.assign(Object.assign({}, basePostParams), { body: JSON.stringify(body), headers: {
            'Content-Type': 'application/json',
        } });
    const result = yield fetch(dispatch, {})(`${conf.API_URL}/api/avatax/salestax`, postParams);
    return result;
});
export const getReturnsSalesTax = () => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { subtotal: amount } = selectReturnsPricingData(state);
    if (amount === 0) {
        dispatch(setReturnsSalesTax(0));
        return;
    }
    const items = [{
            id: 'avaReturns',
            amount,
            taxCode: 'SP140000',
        }];
    const contact = getContact(state);
    if (contact == null || contact === 'ERROR') {
        dispatch(setReturnsSalesTax(contact));
        return;
    }
    const result = yield getSalesTax({ items, contact }, dispatch);
    if (result.ok && result.value.unauthenticatedUser !== true) {
        const salestax = result.value.lines.map(line => line.taxCalculated)[0];
        dispatch(setReturnsSalesTax(salestax !== null && salestax !== void 0 ? salestax : null));
    }
});
export const getRiskAssessmentSalestax = () => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { subTotal } = getRiskAssessmentPricingData(state);
    if (subTotal === 0) {
        dispatch(setRiskAssessmentSalesTax(0));
        return;
    }
    const items = [{
            id: 'riskAssessment',
            amount: subTotal,
            taxCode: 'SP140000',
        }];
    const contact = getContact(state);
    if (contact == null || contact === 'ERROR') {
        dispatch(setRiskAssessmentSalesTax(contact));
        return;
    }
    const result = yield getSalesTax({ items, contact }, dispatch);
    if (result.ok && result.value.unauthenticatedUser !== true) {
        const salestax = result.value.lines.map(line => line.taxCalculated)[0];
        dispatch(setRiskAssessmentSalesTax(salestax !== null && salestax !== void 0 ? salestax : null));
    }
});
export const getConnectorSalesTax = () => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const { account, avataxSignup, sharedSignup, system } = getState();
    const { signupForm } = sharedSignup;
    const { activeFlow } = system;
    const { selectedConnector } = avataxSignup;
    const isAvataxDirectBuy = activeFlow === 'avatax-direct-buy';
    const metadata = (isAvataxDirectBuy ? selectedConnector === null || selectedConnector === void 0 ? void 0 : selectedConnector.metadata : account.connector.metadata);
    const connectorId = isAvataxDirectBuy ? selectedConnector === null || selectedConnector === void 0 ? void 0 : selectedConnector.id : account.connector.id;
    const items = metadata ? Object.values(metadata).map(value => ({
        id: `${connectorId}-tier${value.tierNumber}`,
        amount: value.recurringPrice + (value.waived ? 0 : value.activationPrice),
        taxCode: 'SW052000',
    })) : [];
    let contact;
    if (isAvataxDirectBuy) {
        contact = {
            street: [signupForm.street1, signupForm.street2].filter(Boolean).join(' '),
            state: signupForm.state,
            postalCode: signupForm.postalCode,
            city: signupForm.city,
            country: 'US',
        };
    }
    else {
        contact = getContact(getState());
        if (!contact)
            return;
    }
    const postParams = Object.assign(Object.assign({}, basePostParams), { body: JSON.stringify({
            avataxAccountId: account.accountId,
            items,
            contact,
        }), headers: {
            'Content-Type': 'application/json',
        } });
    const result = yield fetch(dispatch, {})(`${conf.API_URL}/api/avatax/salestax`, postParams);
    if (result.ok && result.value.unauthenticatedUser !== true) {
        dispatch(receiveConnectorSalesTax(result.value.lines));
    }
    else if (!result.ok && result.message === 'no billing contact found') {
        dispatch(getSystemErrorMessaging({ errorCode: 'noBillingContact' }));
    }
});
export const getCountries = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield fetch(dispatch)(`${conf.API_URL}/api/avatax/countries`);
    if (!result.ok)
        return;
    const sortedCountries = result.value.value.sort(({ name: a }, { name: b }) => (a < b ? -1 : 1));
    dispatch(setCountriesData(sortedCountries));
});
export const getRegions = (country) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const { data: { regions } } = getState();
    if (regions[country] != null)
        return;
    const result = yield fetch(dispatch)(`${conf.API_URL}/api/avatax/countries/${country}/regions`);
    if (!result.ok) {
        dispatch(setRegionsData({ regions: [], country }));
        return;
    }
    const sortedRegions = result.value.value.sort(({ name: a }, { name: b }) => (a < b ? -1 : 1));
    dispatch(setRegionsData({ regions: sortedRegions, country }));
});
export const resolveAddress = (body, dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const postParams = Object.assign(Object.assign({}, basePostParams), { body: JSON.stringify(body) });
    const result = yield fetch(dispatch)(`${conf.API_URL}/api/avatax/address/resolve`, postParams);
    if (result.ok)
        return result;
    return result;
});
